/* global angular, $ */
angular.module('ua5App')
    .directive('post', ['$sce', '$rootScope', '$timeout', function($sce, $rootScope, $timeout) {
        return {
            restrict: 'A',
            templateUrl: 'components/post/post.html',
            scope: {
                postData: '='
            },
            link: function($scope, element, attrs) {

                $scope.postData.body = $sce.trustAsHtml($scope.postData.body);

                $scope.rolloverArticle = function(data) {
                    $scope.$emit('rolloverArticle', data);
                };

                $scope.changePostFilter = function($event, args) {
                    $rootScope.$broadcast('postFilterUpdate', args);
                    $event.stopPropagation();
                    $event.preventDefault();
                };

                // reveal post
                //imagesLoaded(element, function() {
                $timeout(function() {
                    $(element).find('.post').animate({
                        opacity: 1
                    }, 250);
                });
                //});
            }
        };
    }])
;
